import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';

import { Button } from 'reactstrap';

import Parametri from '../../parametri';
import Clessidra from '../Clessidra.js';

import { Page, Text, View, Document, Image, PDFViewer, pdf } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';

import { setHyphenationCallback } from '@react-pdf/renderer';

/*
PARAMETRI DA PASSARE
titolo=Titolo del documento, stampato sotto i dati della società
testo=ipertesto
azione="visualizza" o "scarica"
callback=funzione da richiamare quando azione è visualizza e l'utente preme il bottone Chiudi

SINTASSI DELL'IPERTESTO
Vedi commento in modulistica_precompilata.php
*/

function VisualizzaModulo(props) {

    const STATO_INDEFINITO = 0;
    const STATO_RICERCA_DATI = 1;
    const STATO_VISUALIZZA_PDF = 2;
    const STATO_DOWNLOAD_PDF = 3;

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [larghezzaPdf,setLarghezzaPdf] = useState(0);
    const [fileLogo,setFileLogo]=useState('');
    const [typeLogo,setTypeLogo]=useState('');
    const [nomeSocieta,setNomeSocieta]=useState('');
    const [capSocieta,setCapSocieta]=useState('');
    const [cittaSocieta,setCittaSocieta]=useState('');
    const [indirizzoSocieta,setIndirizzoSocieta]=useState('');
    const [pIvaSocieta,setPIvaSocieta]=useState('');
    const [codiceFiscaleSocieta,setCodiceFiscaleSocieta]=useState('');

    var elem = document.getElementById("cont");

    useEffect(() => {
          if(elem) setLarghezzaPdf(elem.getBoundingClientRect().width); 
    },[elem]);

    useEffect(() => {
        if (statoPagina==STATO_DOWNLOAD_PDF) {
            downloadModuloPDF();
        }
    },[statoPagina])

    function scaricaLogo() {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({op:"ricercaLogo", emak: props.emak,sessionId: props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
          .then(risposta => risposta.json())
          .then(
          (valoreDiRitorno) => {          
              if(valoreDiRitorno.risultatoOperazione===1){
                  if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
                    setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
                    setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
                    setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
                    setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
                    setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
                    setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
                    setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
                    setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
                  }

                  if (props.azione=='visualizza') {                    
                    setStatoPagina(STATO_VISUALIZZA_PDF);
                  } else {
                    setStatoPagina(STATO_DOWNLOAD_PDF);
                  }
              }
          },
          (error) => {console.log("Errore connessione");}
        );        
    }    

    useEffect(() => {
        setStatoPagina(STATO_RICERCA_DATI);
        scaricaLogo();        
    }, [])

    const parseHtmlTags = (text) => {
        const elements = [];
        const regex = /(<br>(.*?)<\/br>)|(<r>(.*?)<\/r>)|(<bi>(.*?)<\/bi>)|(<b>(.*?)<\/b>)|(<i>(.*?)<\/i>)/g;
        let lastIndex = 0;
        let match;
        let index = 0;

        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                elements.push(text.substring(lastIndex, match.index));
            }

            if (match[1]) {
                // <br> → bold rosso
                elements.push(
                    <Text key={`br-${index++}`} style={styles.tRossoGrassetto}>{match[2]}</Text>
                );
            } else if (match[3]) {
                // <r> → solo rosso
                elements.push(
                    <Text key={`r-${index++}`} style={styles.tRosso}>{match[4]}</Text>
                );
            } else if (match[5]) {
                elements.push(
                    <Text key={`bi-${index++}`} style={styles.tGrassettoInclinato}>{match[6]}</Text>
                );
            } else if (match[7]) {
                elements.push(
                    <Text key={`b-${index++}`} style={styles.tGrassetto}>{match[8]}</Text>
                );
            } else if (match[9]) {
                elements.push(
                    <Text key={`i-${index++}`} style={styles.tInclinato}>{match[10]}</Text>
                );
            }

            lastIndex = regex.lastIndex;
        }

        if (lastIndex < text.length) {
            elements.push(text.substring(lastIndex));
        }

        return elements;
    };

    const renderRiga = (riga, i) => {
        // RIGA VUOTA
        if (riga.trim() === "") {
            return (
                <Text key={i} style={{ fontSize: 6, marginBottom: 8 }}>{" "}</Text>
            );
        }

        // Avviso rosso
        if (riga.startsWith("@@") && riga.endsWith("@@")) {
            return (
            <Text key={i} style={[styles.t12, styles.tCentrato, styles.tSpaziatoSopra, styles.tSpaziatoSotto]}>
                {parseHtmlTags(riga.slice(2, -2))}
            </Text>
            );
        }

        // Testo centrato
        if (riga.startsWith("@@") && riga.endsWith("@@")) {
            return (
            <Text key={i} style={[styles.t12, styles.tCentrato, styles.tSpaziatoSopra, styles.tSpaziatoSotto]}>
                {parseHtmlTags(riga.slice(2, -2))}
            </Text>
            );
        }

        // Elenco puntato
        if (riga.startsWith("- ")) {
            return (
            <Text key={i} style={styles.t12}>
                • {parseHtmlTags(riga.substring(2))}
            </Text>
            );
        }

        // Riga normale
        return (
            <Text key={i} style={styles.t12}>
                {parseHtmlTags(riga)}
            </Text>
        );
    };

    const DocumentoPDF = (props) => {
        return (
          <Document>
            <Page size="A4" orientation="portrait" style={styles.page}>
                <View style={{width:"100%"}} >
                    <View style={styles.tableIntestazione}>{/*apre table intestazione*/}
                        <View wrap={false} style={styles.tableRowIntestazione}> 
                            <View style={styles.tableColIntestazioneSx}> 
                                <View style={styles.tableCell}> 
                                    {fileLogo !== "" ? <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />:<Text></Text>}                                    
                                </View> 
                            </View> 
                            <View style={styles.tableColIntestazioneDx}>   
                                <View style={styles.tableCellIntestazione}> 
                                    {nomeSocieta !== "" ?<Text style={styles.nomesocieta}>{nomeSocieta}</Text>:<Text></Text>}
                                    
                                    {indirizzoSocieta !== "" ?
                                        <Text style={styles.datisocieta}>{indirizzoSocieta}
                                        {cittaSocieta !== "" ?
                                            capSocieta !== "" ?
                                                " "+capSocieta+" "+cittaSocieta
                                            :" "+cittaSocieta
                                        :""}
                                        </Text>
                                    :<Text></Text>}
                                    {pIvaSocieta !== "" ?<Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text>:<Text></Text>}
                                    {codiceFiscaleSocieta !== "" ?<Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text>:<Text></Text>}
                                    
                                    <Text style={styles.titolo}>
                                        {props.titolo}
                                    </Text>
                                </View> 
                            </View> 
                        </View> 
                    </View>{/*chiude table intestazione*/}

                    <View> 
                        {props.testo.split('\n').map(renderRiga)}
                    </View>  

                </View>
            </Page>
          </Document>
        )
    };

    async function downloadModuloPDF() {
        const blob = await pdf(<DocumentoPDF {...props} />).toBlob(); // Convert the document to a Blob
        const url = URL.createObjectURL(blob); // Create a temporary URL
        const link = document.createElement("a"); // Create a link element
        link.href = url; // Assign the Blob URL
        link.download = "Modulo"; // Set the download filename
        document.body.appendChild(link); // Append the link to the document
        link.click(); // Simulate a click to trigger the download
        document.body.removeChild(link); // Clean up
        URL.revokeObjectURL(url); // Release the memory        
    }

    if (statoPagina==STATO_RICERCA_DATI) {
        const h = props.dimensioniApp?props.dimensioniApp.yMain:"";
        return (<div style={{height: h,width: "100%",display:"flex"}}><Clessidra loading={true}/></div>)
    }

    if (statoPagina==STATO_VISUALIZZA_PDF) {
        const h = props.dimensioniApp?props.dimensioniApp.yMain:"";
        return (
            <div style={{display:"flex", flexDirection:"column", height: h}}>
                <PDFViewer style={{width: "100%", flex:1}}>
                    <DocumentoPDF {...props}/>
                </PDFViewer>
                <Button color="primary" style={{margin:2 }} onClick={() => props.callback()}>Chiudi</Button>
            </div>
        );
    }

    if (statoPagina==STATO_DOWNLOAD_PDF) {
        return (<></>);
    }

    return(
        <div>Errore VisualizzaModulo: pagina non trovata</div>
    )
}

export default VisualizzaModulo;